import grid from "../../../../image/grid.png";
import ElementContext from "../ElementModal";
import {
  CachingMechanisms,
  FileHandling,
  AuthenticationUtilities,
  EncryptionUtilities,
  EmailHandling,
  DataCompression,
  DependencyInjection,
  UtilitiesLibrary,
  Statistics,
  SearchAndIndexing,
} from "../../../../../../../../constants/db";

interface ImageTextObject {
  image: string;
  text: string;
  sourceCode: string;
  description: string;
}

const textLists: ImageTextObject[] = [
  {
    image: grid,
    text: "Caching Mechanisms",
    sourceCode: CachingMechanisms.code,
    description: CachingMechanisms.description,
  },
  {
    image: grid,
    text: "File Handling",
    sourceCode: FileHandling.code,
    description: FileHandling.description,
  },
  {
    image: grid,
    text: "Authentication Utilities",
    sourceCode: AuthenticationUtilities.code,
    description: AuthenticationUtilities.description,
  },
  {
    image: grid,
    text: "Encryption Utilities",
    sourceCode: EncryptionUtilities.code,
    description: EncryptionUtilities.description,
  },
  {
    image: grid,
    text: "Email Handling",
    sourceCode: EmailHandling.code,
    description: EmailHandling.description,
  },
  {
    image: grid,
    text: "Data Compression",
    sourceCode: DataCompression.code,
    description: DataCompression.description,
  },
  {
    image: grid,
    text: "Dependency Injection",
    sourceCode: DependencyInjection.code,
    description: DependencyInjection.description,
  },
  {
    image: grid,
    text: "Utilities Library",
    sourceCode: UtilitiesLibrary.code,
    description: UtilitiesLibrary.description,
  },
  {
    image: grid,
    text: "Statistics",
    sourceCode: Statistics.code,
    description: Statistics.description,
  },
  {
    image: grid,
    text: "Search and Indexing",
    sourceCode: SearchAndIndexing.code,
    description: SearchAndIndexing.description,
  },
];

export default function UtilitiesPage() {
  return (
    <section className="layoutPages">
      {" "}
      <h2 className="layoutPages_heading">Utility components</h2>
      <p className="layoutPages_info">
        Here is a list of all the prebuilt form components that PlayBox makes
        available for use.
      </p>
      {/* compoonets */}
      <div>
        <ElementContext imageTextArray={textLists} />
      </div>
      <p className="coming-soon"> More coming soon ✌️ </p>
    </section>
  );
}
